export class ErrorViewModel {
    errorCode?: string | undefined;
    exception?: string | undefined;
    errorMessages?: string[] | undefined;
    success?: boolean | false;
}